/**
 * Compose utility for Apollo Client v3 migration
 * Replaces the compose function that was removed from react-apollo
 */
const compose = (...funcs) => {
  if (funcs.length === 0) return (arg) => arg;
  if (funcs.length === 1) return funcs[0];
  return funcs.reduce((a, b) => (...args) => a(b(...args)));
};

export default compose;
